import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SessionService } from '../../session.service'
import { Router} from '@angular/router';
@Component({
  moduleId: module.id,
  selector: 'main-navbar',
  templateUrl: 'main-navbar.component.html',
  styleUrls: ['main-navbar.component.scss'],
  host: {
    '[class.app-navbar]': 'true',
    '[class.show-overlay]': 'showOverlay'
  }
})
export class MainNavbarComponent implements OnInit {
  @Input() title: string;
  @Input() openedSidebar: boolean = false;
  @Input() openedAddition: boolean = false;
  @Output() sidebarState = new EventEmitter();
  @Output() additionState = new EventEmitter();
  showOverlay: boolean = false;
  nameLogin:String;
  constructor(private router: Router,private _sessionService:SessionService) {
    if(this._sessionService.getSessionLogin()){
      this.nameLogin = this._sessionService.getSessionName();
    }
  }

  open(event) {
    let clickedComponent = event.target.closest('.nav-item');
    let items = clickedComponent.parentElement.children;

    event.preventDefault();

    for (let i = 0; i < items.length; i++) {
      items[i].classList.remove('opened');
    }
    clickedComponent.classList.add('opened');

    //Add class 'show-overlay'
    this.showOverlay = true;
  }

  close(event) {
    let clickedComponent = event.target;
    let items = clickedComponent.parentElement.children;

    event.preventDefault();

    for (let i = 0; i < items.length; i++) {
      items[i].classList.remove('opened');
    }

    //Remove class 'show-overlay'
    this.showOverlay = false;

    //Close addition navbar
    if (this.openedAddition) {
      this.openedAddition = false;
      this.additionState.emit();
    }
  }

  openAddition(event) {
    let clickedComponent = event.target.closest('.nav-item');
    let items = clickedComponent.parentElement.children;

    event.preventDefault();

    for (let i = 0; i < items.length; i++) {
      items[i].classList.remove('opened');
    }
    clickedComponent.classList.add('opened');

    //Add class 'show-overlay'
    this.showOverlay = true;

    //Open addition navbar
    this.openedAddition = !this.openedAddition;
    this.additionState.emit();
  }

  logout(){
    this._sessionService.sessionDestroy('isLogin');
    this._sessionService.sessionDestroy('permission');
    this._sessionService.sessionDestroy('usersid');
    this._sessionService.sessionDestroy('name');
    //this.router.navigateByUrl('extra-layout/sign-in');
    //this.refresh();
    }

  openSidebar() {
    this.openedSidebar = !this.openedSidebar;
    this.sidebarState.emit();
  }

  ngOnInit() { }
}



// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/ui/main-navbar/main-navbar.component.ts